import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faShoppingCart,
  faPlay,
  faPause,
} from "@fortawesome/free-solid-svg-icons";
import StarRatingBasic from "./StarRatingBasic";
import CourseDetailsModal from "./CourseDetailsModal";

function BannerSliderThumb({ 
  item, 
  addToCart, 
  isUSDCurrency, 
  onDetailsButtonClick,
  onPlayVideo,
  onPauseVideo,
  playingId,
  isVideoPlaying
}) {
  const [show, setShow] = useState(false);
  const isActive = playingId === item?.CourseId;
  const showPause = isActive && isVideoPlaying;

  const handleClose = () => setShow(false);
  
  const handleShow = () => {
    onDetailsButtonClick(); // Stops video via parent (sets isVideoPlaying=false + playingId=null)
    setShow(true);
  };

  const handlePlayPauseClick = (e) => {
    e.stopPropagation();
    if (showPause && onPauseVideo) {
      onPauseVideo(item.CourseId);
    } else if (onPlayVideo) {
      onPlayVideo(item.CourseId);
    }
  };

  return (
    <>
      <div 
        className={`banner-thumbs-slider-card position-relative ${isActive ? 'thumb-active-playing' : ''}`} 
        key={item?.CourseId}
        style={isActive ? { 
          boxShadow: '0 0 0 3px #0d6efd, 0 4px 12px rgba(13, 110, 253, 0.35)',
          transform: 'scale(1.02)',
          transition: 'all 0.2s ease'
        } : {}}
      >
        <img
          className="d-block w-100"
          src={item?.CourseImageURL200H}
          alt="banner"
        />

        <div 
          className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center"
          style={{ zIndex: 10 }}
          onClick={handlePlayPauseClick}
        >
          <button
            className="btn rounded-circle shadow-lg d-flex align-items-center justify-content-center"
            style={{
              width: "54px",
              height: "54px",
              fontSize: "1.4rem",
              background: "rgba(0, 0, 0, 0.65)",
              color: "#fff",
              border: isActive ? "3px solid #0d6efd" : "2px solid rgba(255,255,255,0.6)",
              transition: "all 0.2s ease"
            }}
            aria-label={showPause ? "Pause video" : "Play intro video"}
            title={showPause ? "Pause video" : "Play intro video"}
          >
            <FontAwesomeIcon icon={showPause ? faPause : faPlay} />
          </button>
        </div>

        {isActive && (
          <div 
            className="position-absolute top-0 start-0 m-2 px-2 py-0 rounded-pill bg-primary text-white small"
            style={{ fontSize: "0.65rem", zIndex: 11, opacity: 0.95 }}
          >
            Now Playing
          </div>
        )}

        <div className="top">
          <h4>By: {item?.CoursePublisher}</h4>
        </div>

        <div className="bottom">
          <h3>{item?.CourseTitle}</h3>
          <div className="control flex-wrap">
            <div className="rate my-1">
              <div className="rate-stars d-flex align-items-center">
                {StarRatingBasic(item?.CourseRating, "white")}
              </div>
            </div>
            <div className="buttons">
              <button className="buy" onClick={() => {}}>
                <i><FontAwesomeIcon icon={faShoppingCart} /></i>
              </button>
              <a className="details-btn" type="button" onClick={handleShow}>
                <span>Details</span>
                <i><FontAwesomeIcon icon={faArrowRight} /></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {show && (
        <CourseDetailsModal
          courseData={item}
          show={show}
          handleClose={handleClose}
          isUSDCurrency={isUSDCurrency}
          addToCart={addToCart}
        />
      )}
    </>
  );
}

export default BannerSliderThumb;
